// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-footer[data-v-4262c764]{position:sticky;bottom:0;padding:16px;background-color:#fff}@media screen and (max-width:600px){.form-footer[data-v-4262c764]{padding:5px}}.container[data-v-4262c764]{margin-top:1em}.bg-footer[data-v-4262c764]{background:#fff}.fixed-button[data-v-4262c764]{position:fixed;top:10px;right:10px}", ""]);
// Exports
module.exports = exports;
